import { useEffect, useState } from 'react'

import {
  Box,
  Icon,
  Modal,
  Text,
  ThemeColors,
  getThemeColor,
} from '@fairfashion/design-system'
import Parser from 'html-react-parser'
import { useLocation } from 'react-router-dom'
import { useTheme } from 'styled-components'

import { ITutorial } from '../../../../sdk/settings/settings.types'
import { sdk } from '../../../../services/sdk'
import { SidebarItem } from '../SidebarItem/sidebar-item.comp'

import * as Styles from './tutorial.styles'

export const Tutorial = () => {
  const [open, setOpen] = useState(false)
  const [tutorial, setTutorial] = useState<ITutorial>()
  const [showTutorial, setShowTutorial] = useState(false)
  const [showTutorialNotification, setShowTutorialNotification] =
    useState(false)
  const theme = useTheme()

  const location = useLocation()

  const filteredPathname = location.pathname.includes('/company/')
    ? '_company'
    : location.pathname.replace(/\//g, '_')

  const getTutorial = async () => {
    try {
      const response = await sdk.settings.getTutorial(filteredPathname)
      setShowTutorial(true)
      if (
        localStorage.getItem(`_cookieTutorial${response.tag}`) ===
        response.updatedAt.toString()
      ) {
        setShowTutorialNotification(false)
      } else {
        setShowTutorialNotification(true)
      }
      setTutorial(response)
    } catch (error) {
      setShowTutorial(false)
    }
  }

  useEffect(() => {
    getTutorial()
  }, [location])

  const handleOpenTutorial = () => {
    setOpen(true)
    tutorial && setShowTutorialNotification(false)
    tutorial &&
      localStorage.setItem(
        `_cookieTutorial${tutorial.tag}`,
        tutorial.updatedAt.toString(),
      )
  }

  return (
    <Box width="100%">
      {showTutorial && (
        <SidebarItem
          icon="question"
          title="Tutorial"
          onClick={handleOpenTutorial}
          pending={showTutorialNotification}
          customText={
            <Box gap={1} alignItems="center">
              <Icon
                name={'question'}
                color={`${getThemeColor('white', theme) + 'C4'}` as ThemeColors}
                size={20}
              />
              <Text
                variant="p"
                size="small"
                color={`${getThemeColor('white', theme) + 'C4'}` as ThemeColors}
              >
                Tutorial
              </Text>
            </Box>
          }
        />
      )}
      {tutorial && (
        <Modal
          open={open}
          onClose={() => setOpen(false)}
          title="Tutorial"
          maxWidth="90%"
          width="800px"
        >
          <Styles.TutorialWrapper direction="column" width="100%" padding={3}>
            {Parser(tutorial?.text)}
          </Styles.TutorialWrapper>
        </Modal>
      )}
    </Box>
  )
}
